/**
 * Vulnerability Status Label Mapping Utility
 *
 * Maps backend RiskStatus enum values to display labels.
 */

import { RiskStatus } from '@/types';

const STATUS_LABELS: Record<RiskStatus, string> = {
  [RiskStatus.Triaged]: 'Detected',
  [RiskStatus.Opened]: 'Demonstrated',
  [RiskStatus.Remediated]: 'Resolved',
  [RiskStatus.Accepted]: 'Accepted',
  [RiskStatus.Deleted]: 'Rejected',
} as const;

/**
 * Returns the display label for a vulnerability status.
 */
export function getStatusLabel(backendStatus: RiskStatus): string {
  return STATUS_LABELS[backendStatus] ?? backendStatus;
}
